angular.module("ainapp")
    .controller("voucherDocumentsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Voucher Documents";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {}
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        MainService.VoucherDocsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            ExpiryDate: {
                                type: "date",
                                editable: false,
                            },
                            UploadDate: {
                                type: "date",
                                editable: false,
                            },
                            FileName: {
                                type: "string",
                                editable: false,
                            },
                            FilePath: {
                                type: "string",
                                editable: false,
                            },
                            Remarks: {
                                type: "string",
                                editable: false,
                            },
                            VoucherType: {
                                type: "string",
                                editable: false,
                            },
                            VoucherNo: {
                                type: "string",
                                editable: false,
                            },
                            VoucherId: {
                                type: "number",
                                editable: false,
                            },
                            "User.UserName": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {


                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "VoucherType",
                        title: "Voucher Type",
                            },
                    {
                        field: "VoucherNo",
                        title: "Voucher No",
                            },
                    {
                        field: "FileName",
                        title: "File Name",
                            },
                    {
                        field: "ExpiryDate",
                        title: "Expiry Date",
                        template: "#= kendo.toString(kendo.parseDate(ExpiryDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",

                            },
                    {
                        field: "User.UserName",
                        title: "Created By",
                            },
                    {
                        field: "UploadDate",
                        title: "Created Date",
                        template: "#= kendo.toString(kendo.parseDate(UploadDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",

                            },
                    {
                        field: "Remarks",
                        title: "Remarks",
                            },
                    {
                        field: "Attachment",
                        title: "Attachment",
                        template: '<a href="{{basePath}}{{dataItem.FilePath}}" target="_blank"> View File </a>'
                            },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                    },

                    ],
            };


            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteVoucherDoc($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }


        }])
